import React from 'react';

const AlignRightIcon = props => (
  <svg viewBox="0 0 20 18" {...props}>
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <g transform="translate(-219.000000, -16.000000)">
        <path d="M219,16 L233,16 L233,18 L219,18 L219,16 Z M219,20 L227,20 L227,22 L219,22 L219,20 Z M219,24 L227,24 L227,26 L219,26 L219,24 Z M219,28 L227,28 L227,30 L219,30 L219,28 Z M219,32 L233,32 L233,34 L219,34 L219,32 Z M229,20 L239,20 L239,30 L229,30 L229,20 Z"/>
      </g>
    </g>
  </svg>
);

export default AlignRightIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/align-right-icon.js